import moment from 'moment-timezone'

class ClockInController {
  /* @ngInject */
  constructor (roster, $mdDialog, clockIn, $mdpTimePicker, onClockInOutUpdate, $mdMenu) {
    this.$mdDialog = $mdDialog
    this.worker = roster
    this.option = 'SHIFT_TIME'
    this.moment = moment
    // Formatted shift start time
    this.shiftStartTime = moment(roster.start_time).tz(roster.timezone).format('ddd, MMM D [at] h:mm A')
    // Formatted shift end time
    this.shiftEndTime = moment(roster.end_time).tz(roster.timezone).format('ddd, MMM D [at] h:mm A')
    this.title = clockIn ? 'Clock In' : 'Clock Out'
    this.customTime = ''
    this.clockIn = clockIn
    this.customTimeEnabled = this.option === 'CUSTOM_TIME';
    this.$mdMenu = $mdMenu
    this.clockInOutDate = new Date()
    this.dateRange = this.getDateRange(roster.start_time)
    this.onClockInOutUpdate = onClockInOutUpdate
  }

  getDateRange (startDate) {
    // We can Clock In/Out only in such days range
    const today = moment(startDate).toDate();
    const tomorrow = moment(today).add(1,'days').toDate();
    const yesterday = moment(today).add(-1, 'days').toDate();
    return [yesterday, today, tomorrow];
  }

  setClockInOutDate (date) {
    // Set selected date
    this.clockInOutDate = date;
  }

  updateTime () {
    // Current time and date
    let time = moment().tz(this.worker.timezone).format();
    // Shift start time
    if (this.option === 'SHIFT_TIME') {
      if (this.clockIn) {
        time = moment(this.worker.start_time).tz(this.worker.timezone).format();
      } else {
        time = moment(this.worker.end_time).tz(this.worker.timezone).format();
      }
    }
    // Custom Time and Date
    if (this.option === 'CUSTOM_TIME') {
      const customDate = moment(this.clockInOutDate).tz(this.worker.timezone).format();
      const hour = moment(this.customTime).get('hour');
      const minute = moment(this.customTime).get('minute');
      const second = moment(this.customTime).get('second');
      const setTime = moment(customDate).set({ hour, minute, second });
      time = setTime.tz(this.worker.timezone, true).format();
    }

    this.onClockInOutUpdate(time);
    this.$mdDialog.cancel();
  }

  cancel () {
    // Close Clock In/Out modal
    this.$mdDialog.cancel()
  }
}

export default ClockInController
